var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.71 16.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "m15.77,16.18H3.94c-2.17,0-3.94-1.77-3.94-3.94V3.94C0,1.77,1.77,0,3.94,0h11.83c2.17,0,3.94,1.77,3.94,3.94v8.3c0,2.17-1.77,3.94-3.94,3.94ZM3.94,1c-1.62,0-2.94,1.32-2.94,2.94v8.3c0,1.62,1.32,2.94,2.94,2.94h11.83c1.62,0,2.94-1.32,2.94-2.94V3.94c0-1.62-1.32-2.94-2.94-2.94H3.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "m9.81,8.46c-.54,0-1.09-.16-1.56-.49l-4.71-3.25c-.23-.16-.28-.47-.13-.7.16-.23.47-.28.7-.13l4.71,3.25c.61.42,1.43.41,2.03-.04l4.32-3.21c.22-.16.53-.12.7.1.16.22.12.53-.1.7l-4.32,3.21c-.48.36-1.06.54-1.64.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.bb494f7f4743880e1ebd98ca29b9d58b.svg";
export { ForwardRef as ReactComponent };